import BaseService from './base-service.js'

const baseUrlStores = '/stores/bo'

export default {
    async getStores() {
        const { data } = await BaseService.get(`${baseUrlStores}/stores`)
        return data
    },

    async getStore(id) {
        const { data } = await BaseService.get(`${baseUrlStores}/store/${id}`)
        return data
    },
}
